import { render } from "./FlowPanelElementWrapper.vue?vue&type=template&id=8e87f4b4&scoped=true&ts=true"
import script from "./FlowPanelElementWrapper.vue?vue&type=script&lang=ts"
export * from "./FlowPanelElementWrapper.vue?vue&type=script&lang=ts"

import "./FlowPanelElementWrapper.vue?vue&type=style&index=0&id=8e87f4b4&lang=scss&scoped=true"

import exportComponent from "/Users/alexanderclaas/Documents/Epic AI/ChatCaptain/chatcaptain-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8e87f4b4"]])

export default __exports__